(() => {
  if (window.riseTapeProofReady) return;
  window.riseTapeProofReady = true;
  let opener = null;
  let previousOverflow = '';
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-rtp-open]');
    if (!trigger || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const dialog = document.getElementById(trigger.dataset.rtpOpen);
    if (!dialog || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    const video = dialog.querySelector('video');
    opener = trigger;
    if (!video.getAttribute('src')) video.src = video.dataset.src;
    previousOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    dialog.querySelector('[data-rtp-close]').focus({preventScroll:true});
    video.play().catch(() => { /* Native play controls remain available. */ });
    if (dialog.dataset.rtpBound) return;
    dialog.dataset.rtpBound = 'true';
    dialog.querySelector('[data-rtp-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => {
      if (e.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      video.pause();
      document.documentElement.style.overflow = previousOverflow;
      if (opener?.isConnected) opener.focus({preventScroll:true});
    });
    video.addEventListener('error', () => { dialog.querySelector('.rtp-dialog__fallback').hidden = false; });
  });
})();
